<template>
  <v-list-item class="pa-0 my-2">
    <v-list-item-content class="px-0">
      <v-row>
        <v-col cols="12" md="7" class="py-0">
          <span class="subtitle-1">
            <b>{{ berkas.title }}</b>
          </span>
          <p class="body-2 grey--text text--darken-1 mb-0" v-html="berkas.pesan" />
          <div v-if="berkas.url_template">
            <v-btn text small depressed elevation="0" color="info" class="text-capitalize pa-0">
              <v-icon x-small left class="mr-0">mdi-download</v-icon> Unduh template
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="5" class="pa-0">
          <v-container class="py-0">
            <v-row>
              <v-col cols="12" md="4" class="pb-0">
                <div>
                  <v-label color="caption"><small>status</small></v-label>
                </div>
                <v-chip :class="`${valid ? 'green' : optional ? 'grey' : 'red'} white--text`" small>
                  {{ valid ? 'Selesai' : optional ? 'Tidak wajib' : 'Belum' }}
                </v-chip>
              </v-col>
              <v-col cols="12" md="4" class="mt-4" v-if="withAction">
                <v-btn depressed small color="blue mr-2" dark @click="onUpload(type)" v-if="valid">
                  <v-icon left class="body-1 mr-1">mdi-pencil</v-icon>
                  Ubah
                </v-btn>
                <v-btn depressed small color="orange darken-2 mr-2" dark @click="onUpload(type)" v-else>
                  <v-icon left class="body-1 mr-1">mdi-upload</v-icon> Unggah
                </v-btn>
              </v-col>
              <v-col cols="12" md="4" class="mt-4">
                <v-btn depressed small color="blue mr-2" dark v-if="valid" @click="onView">
                  <v-icon left class="body-1 mr-1">mdi-eye</v-icon> Lihat
                </v-btn>
                <v-btn disabled small v-else><v-icon left>mdi-eye</v-icon> Lihat</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ViewData',
  props: {
    type: {
      type: String,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
    valid: {
      type: Boolean,
      default: false,
    },
    withAction: {
      type: Boolean,
      default: false,
    },
    optional: {
      type: Boolean,
      default: false,
    },
    berkas: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onUpload(type) {
      this.$emit('upload', { type: type });
    },
    onView() {
      this.$downloadFile(this.value && this.value.url_berkas);
    },
  },
};
</script>

<style scoped></style>
